import gsap from "gsap";
import { Mesh, MeshStandardMaterial } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { angelopolisApi } from "../../api/angelopolisAPi";
import model from "../../assets/models/Angelopolis_640.glb";
import { getUrlParamZone } from "../../utils/urlParams";
// import { ModalControler } from "../../components/modals/ModalControler";
// import utyls from "../../utils/";
export class GltfAngelopolis extends Mesh {
  constructor(loadingManager) {
    super();
    let loader = new GLTFLoader(loadingManager);
    let dracoloader = new DRACOLoader();
    this.angelApi = new angelopolisApi();
    dracoloader.setDecoderPath(
      "https://www.gstatic.com/draco/versioned/decoders/1.5.5/"
    );
    this.loading = loader;
    loader.setDRACOLoader(dracoloader);
    this.rombos = [];
    this.lotes = [];
    this.allLotes = [];
    this.modelsHoverClousters = [];
    this.dataAPI = [];
    this.getDataCloustersApi();

    this.onLoadModel(loader);
    this.scale.set(1, 1, 1);
    this.position.set(120, -8, -290);
    // this.rotation.y += 0.03;
  }

  async getDataCloustersApi() {
    this.dataAPI = this.angelApi.getApiData();
  }

  // "Z_nuevaZona1""Priv_santa_monica4"
  onLoadModel(loader) {
    loader.load(model, (gltf) => {
      this.add(gltf.scene);
      (this.flech1 = gltf.scene.getObjectByName(
        "Acceso1_flecha_MT_G_iconos_0"
      )),
        (this.flech2 = gltf.scene.getObjectByName(
          "Acceso2_flecha_MT_G_iconos_0"
        )),
        (this.flech3 = gltf.scene.getObjectByName(
          "Acceso3_flecha_MT_G_iconos_0"
        )),
        (this.flech1.visible = false);
      this.flech2.visible = false;
      this.flech3.visible = false;
      // gltf.scene.getObjectByName("Outline_ZonaNueva", true).getOb.getObjj
      this.Cascatta2 = gltf.scene.getObjectByName(
        "Outline_cascatta_MT_ambientacion_0",
        true
      );
      // this.Glow_sin_lotes =  gltf.scene.getObjectByName("Glow_sin_lotes_MT_G_sinLotes_0", true)
      this.Outline_nuevaZona = gltf.scene.getObjectByName(
        "Outline_nuevaZona_MT_ambientacion_0",
        true
      );
      this.Outline_ZonaNueva = gltf.scene.getObjectByName(
        "Outline_ZonaNueva_MT_ambientacion_0",
        true
      );
      this.Outline_nuevaZona3 = gltf.scene.getObjectByName(
        "Outline_nuevaZona3",
        true
      );
      this.Parques_Amarillo1 = gltf.scene.getObjectByName(
        "Outline_parques_MT_ambientacion_0",
        true
      );
      this.Distrito_escolar_glow = gltf.scene.getObjectByName(
        "Distrito_escolar_glow001",
        true
      );

      this.Vialidad_MT_G_vialidad_0 = gltf.scene.getObjectByName(
        "Vialidad_MT_G_vialidad_0",
        true
      );
      this.Terreno_nuevaZona_MT_G_terreno_0 = gltf.scene.getObjectByName(
        "Terreno_nuevaZona_MT_G_terreno_0",
        true
      );
      this.Outline_cascatta2 = gltf.scene.getObjectByName(
        "Outline_cascatta2",
        true
      );
      //
      this.Hover_fontana_MT_ambientacion_0 = gltf.scene.getObjectByName(
        "Hover_fontana_MT_ambientacion_0",
        true
      );
      this.Hover_sacramento_MT_ambientacion_0 = gltf.scene.getObjectByName(
        "Hover_sacramento_MT_ambientacion_0",
        true
      );
      this.Hover_arcadia_MT_ambientacion_0 = gltf.scene.getObjectByName(
        "Hover_arcadia_MT_ambientacion_0",
        true
      );
      this.Hover_rinconada_MT_ambientacion_0 = gltf.scene.getObjectByName(
        "Hover_rinconada_MT_ambientacion_0",
        true
      );
      this.Hover_galena_MT_hover_clusters_0 = gltf.scene.getObjectByName(
        "Hover_galena_MT_hover_clusters_0",
        true
      );
      this.Hover_capri_hover_cityLomas2_0 = gltf.scene.getObjectByName(
        "Hover_capri_MT_ambientacion_0",
        true
      );
      this.Hover_creta_hover_cityLomas2_0 = gltf.scene.getObjectByName(
        "Hover_creta_MT_ambientacion_0",
        true
      );
      this.Hover_rodas_hover_cityLomas2_0 = gltf.scene.getObjectByName(
        "Hover_rodas_MT_ambientacion_0",
        true
      );
      this.Hover_vilansa_MT_G_hover_Vilansa_0 = gltf.scene.getObjectByName(
        "Hover_vilansa_MT_ambientacion_0",
        true
      );
      this.Hover_bali_MT_hover_clusters_0 = gltf.scene.getObjectByName(
        "Hover_bali",
        true
      );
      this.Hover_parqueBerna_MT_G_hover_zonaAzul_0 = gltf.scene.getObjectByName(
        "Hover_parqueBerna_MT_ambientacion_0",
        true
      );
      this.Hover_parqueSofia_MT_G_hover_zonaAzul_0 = gltf.scene.getObjectByName(
        "Hover_parqueSofia_MT_ambientacion_0",
        true
      );
      this.Hover_palermo_MT_G_hover_zonaAzul_0 = gltf.scene.getObjectByName(
        "Hover_palermo_MT_ambientacion_0",
        true
      );
      this.Hover_parqueViena_MT_G_hover_zonaAzul_0 = gltf.scene.getObjectByName(
        "Hover_parqueViena_MT_ambientacion_0",
        true
      );
      this.Hover_anturio_MT_G_Hover_Anturio_0 = gltf.scene.getObjectByName(
        "Hover_anturio_MT_ambientacion_0",
        true
      );
      this.Hover_balcanes = gltf.scene.getObjectByName("Hover_balcanes", true);
      this.Hover_lucerna = gltf.scene.getObjectByName("Hover_lucerna", true);
      this.Hover_lacantera = gltf.scene.getObjectByName(
        "Hover_lacantera",
        true
      );
      this.Hover_niza = gltf.scene.getObjectByName("Hover_niza", true);
      this.Hover_antalya = gltf.scene.getObjectByName("Hover_antalya", true);

      this.Hover_verona = gltf.scene.getObjectByName("Hover_verona", true);
      this.Hover_trento = gltf.scene.getObjectByName("Hover_trento", true);
      this.Hover_sorrento = gltf.scene.getObjectByName("Hover_sorrento", true);
      this.Hover_zante = gltf.scene.getObjectByName("Hover_zante", true);
      this.Hover_ferrara = gltf.scene.getObjectByName("Hover_Ferrara", true);
      this.Hover_Siena = gltf.scene.getObjectByName("Hover_Siena", true);
      //
      this.Hover_niza.visible = false;
      this.Hover_antalya.visible = false;
      this.Hover_verona.visible = false;
      this.Hover_trento.visible = false;
      this.Hover_sorrento.visible = false;
      this.Hover_zante.visible = false;
      this.Hover_ferrara.visible = false;
      this.Hover_Siena.visible = false;
      this.Hover_fontana_MT_ambientacion_0.visible = false;
      this.Hover_sacramento_MT_ambientacion_0.visible = false;
      this.Hover_arcadia_MT_ambientacion_0.visible = false;
      this.Hover_rinconada_MT_ambientacion_0.visible = false;
      this.Hover_galena_MT_hover_clusters_0.visible = false;
      this.Hover_capri_hover_cityLomas2_0.visible = false;
      this.Hover_creta_hover_cityLomas2_0.visible = false;
      this.Hover_rodas_hover_cityLomas2_0.visible = false;
      this.Hover_vilansa_MT_G_hover_Vilansa_0.visible = false;
      this.Hover_bali_MT_hover_clusters_0.visible = false;
      this.Hover_parqueBerna_MT_G_hover_zonaAzul_0.visible = false;
      this.Hover_parqueSofia_MT_G_hover_zonaAzul_0.visible = false;
      this.Hover_palermo_MT_G_hover_zonaAzul_0.visible = false;
      this.Hover_parqueViena_MT_G_hover_zonaAzul_0.visible = false;
      this.Hover_anturio_MT_G_Hover_Anturio_0.visible = false;
      this.Hover_balcanes.visible = false;
      this.Hover_lucerna.visible = false;
      this.Hover_lacantera.visible = false;

      this.modelsHoverClousters = [
        {
          names: ["Banqueta_fontana_MT_G_terreno_0"],
          model: this.Hover_fontana_MT_ambientacion_0,
          label: "#labelClousterOne",
        },
        {
          names: ["Banqueta_sacramento_MT_G_terreno_0"],
          model: this.Hover_sacramento_MT_ambientacion_0,
          label: "#labelClousterTwo",
        },
        {
          names: ["Banqueta_arcadia_MT_G_terreno_0"],
          model: this.Hover_arcadia_MT_ambientacion_0,
          label: "#labelClousterThree",
        },
        {
          names: ["Banqueta_rinconada_MT_G_terreno_0"],
          model: this.Hover_rinconada_MT_ambientacion_0,
          label: "#labelClousterFour",
        },
        {
          names: ["Galena4"],
          model: this.Hover_galena_MT_hover_clusters_0,
          label: "#labelClousterFive",
        },
        {
          names: ["Banqueta_capri_MT_G_terreno_0"],
          model: this.Hover_capri_hover_cityLomas2_0,
          label: "#twoLabelClousterOne",
        },
        {
          names: ["Banqueta_Creta_MT_G_terreno_0"],
          model: this.Hover_creta_hover_cityLomas2_0,
          label: "#twoLabelClousterTwo",
        },
        {
          names: ["Banqueta_rodas_MT_G_terreno_0"],
          model: this.Hover_rodas_hover_cityLomas2_0,
          label: "#twoLabelClousterThree",
        },
        {
          names: ["Banqueta_bali_MT_G_terreno_0"],
          model: this.Hover_bali_MT_hover_clusters_0,
          label: "#twoLabelClousterFour",
        },
        {
          names: ["Banqueta_vilansa_MT_G_terreno_0"],
          model: this.Hover_vilansa_MT_G_hover_Vilansa_0,
          label: "#threeLabelClousterOne",
        },
        {
          names: ["Banqueta_parqueViena_MT_G_terreno_0"],
          model: this.Hover_parqueViena_MT_G_hover_zonaAzul_0,
          label: "#fiveLabelClousterOne",
        },
        {
          names: ["Banqueta_parqueBerna_MT_G_terreno_0"],
          model: this.Hover_parqueBerna_MT_G_hover_zonaAzul_0,
          label: "#fiveLabelClousterTwo",
        },
        {
          names: ["Banqueta_sofia_MT_G_terreno_0"],
          model: this.Hover_parqueSofia_MT_G_hover_zonaAzul_0,
          label: "#fiveLabelClousterThree",
        },
        {
          names: ["Banqueta_palermo_MT_G_terreno_0"],
          model: this.Hover_palermo_MT_G_hover_zonaAzul_0,
          label: "#fiveLabelClousterFour",
        },
        {
          names: ["Banqueta_anturio_MT_G_terreno_0"],
          model: this.Hover_anturio_MT_G_Hover_Anturio_0,
          label: "#sixLabelClousterOne",
        },
        {
          names: ["Banqueta_balcanes"],
          model: this.Hover_balcanes,
          label: "#sixLabelClousterTwo",
        },
        {
          names: ["Banqueta_lucerna"],
          model: this.Hover_lucerna,
          label: "#sevenLabelClousterOne",
        },
        {
          names: ["Banqueta_lacantera"],
          model: this.Hover_lacantera,
          label: "#SevenLabelClousterTwo",
        },
        {
          names: ["Banqueta_niza"],
          model: this.Hover_niza,
          label: "#twoLabelClousterFive",
        },
        {
          names: ["Banqueta_antalya"],
          model: this.Hover_antalya,
          label: "#twoLabelClousterSix",
        },

        {
          names: ["Banqueta_verona"],
          model: this.Hover_verona,
          label: "#eightLabelClousterTwo",
        },
        {
          names: ["Banqueta_trento"],
          model: this.Hover_trento,
          label: "#eightLabelClousterOne",
        },
        {
          names: ["Banqueta_sorrento"],
          model: this.Hover_sorrento,
          label: "#eightLabelClousterThree",
        },
        {
          names: ["Banqueta_zante"],
          model: this.Hover_zante,
          label: "#threeLabelClousterTwo",
        },
        {
          names: ["Banqueta_Ferrara"],
          model: this.Hover_ferrara,
          label: "#eightLabelClousterFour",
        },
        {
          names: ["Banqueta_Siena"],
          model: this.Hover_Siena,
          label: "#eightLabelClousterFive",
        },
      ];
      //
      this.Lotes00 = gltf.scene.getObjectByName("Lotes", true);
      this.Lotes001 = gltf.scene.getObjectByName("Lotes001", true);
      this.Lotes002 = gltf.scene.getObjectByName("Lotes002", true);
      this.Lotes003 = gltf.scene.getObjectByName("Lotes003", true);
      this.Lotes004 = gltf.scene.getObjectByName("Lotes004", true);
      this.Lotes005 = gltf.scene.getObjectByName("Lotes005", true);
      this.Lotes006 = gltf.scene.getObjectByName("Lotes006", true);
      this.Lotes007 = gltf.scene.getObjectByName("Lotes007", true);
      this.Lotes008 = gltf.scene.getObjectByName("Lotes008", true);
      this.Lotes009 = gltf.scene.getObjectByName("Lotes009", true);
      this.Lotes010 = gltf.scene.getObjectByName("Lotes010", true);
      this.Lotes011 = gltf.scene.getObjectByName("Lotes011", true);
      this.Lotes012 = gltf.scene.getObjectByName("Lotes012", true);
      this.Lotes013 = gltf.scene.getObjectByName("Lotes013", true);
      this.Lotes014 = gltf.scene.getObjectByName("Lotes014", true);
      this.Lotes015 = gltf.scene.getObjectByName("Lotes015", true);
      this.Lotes016 = gltf.scene.getObjectByName("Lotes016", true);
      this.Lotes017 = gltf.scene.getObjectByName("Lotes017", true);
      this.Lotes018 = gltf.scene.getObjectByName("Lotes018", true);
      this.Lotes019 = gltf.scene.getObjectByName("Lotes019", true);

      this.Lotes022 = gltf.scene.getObjectByName("Lotes022", true);
      this.Lotes020 = gltf.scene.getObjectByName("Lotes020", true);
      this.Lotes021 = gltf.scene.getObjectByName("Lotes021", true);
      this.Lotes023 = gltf.scene.getObjectByName("Lotes023", true);
      this.Lotes024 = gltf.scene.getObjectByName("Lotes_Ferrara", true);
      this.Lotes025 = gltf.scene.getObjectByName("Lotes_Siena", true);

      this.Lotes00.visible = false;
      this.Lotes001.visible = false;
      this.Lotes002.visible = false;
      this.Lotes003.visible = false;
      this.Lotes004.visible = false;
      this.Lotes005.visible = false;
      this.Lotes006.visible = false;
      this.Lotes007.visible = false;
      this.Lotes008.visible = false;
      this.Lotes009.visible = false;
      this.Lotes010.visible = false;
      this.Lotes011.visible = false;
      this.Lotes012.visible = false;
      this.Lotes013.visible = false;
      this.Lotes014.visible = false;
      this.Lotes015.visible = false;
      this.Lotes016.visible = false;
      this.Lotes017.visible = false;
      this.Lotes018.visible = false;
      this.Lotes019.visible = false;
      this.Lotes020.visible = false;
      this.Lotes021.visible = false;
      this.Lotes023.visible = false;
      this.Lotes022.visible = false;
      this.Lotes024.visible = false;
      this.Lotes025.visible = false;
      this.allLotes.push(this.Lotes00);
      this.allLotes.push(this.Lotes001);
      this.allLotes.push(this.Lotes002);
      this.allLotes.push(this.Lotes003);
      this.allLotes.push(this.Lotes004);
      this.allLotes.push(this.Lotes005);
      this.allLotes.push(this.Lotes006);
      this.allLotes.push(this.Lotes007);
      this.allLotes.push(this.Lotes008);
      this.allLotes.push(this.Lotes009);
      this.allLotes.push(this.Lotes010);
      this.allLotes.push(this.Lotes011);
      this.allLotes.push(this.Lotes012);
      this.allLotes.push(this.Lotes013);
      this.allLotes.push(this.Lotes014);
      this.allLotes.push(this.Lotes015);
      this.allLotes.push(this.Lotes016);
      this.allLotes.push(this.Lotes017);
      this.allLotes.push(this.Lotes018);
      this.allLotes.push(this.Lotes019);
      this.allLotes.push(this.Lotes020);
      this.allLotes.push(this.Lotes021);
      this.allLotes.push(this.Lotes022);
      this.allLotes.push(this.Lotes023);
      this.allLotes.push(this.Lotes024);
      this.allLotes.push(this.Lotes025);
      if (getUrlParamZone()) {
        this.toggleAllLotes(true);
      }
      this.loteMaterialWhite = gltf.scene
        .getObjectByName("VICTORIA_13_MT_G_disponible_0")
        .material.clone();

      this.Parques_Amarillo1.visible = false;
      this.Distrito_escolar_glow.visible = false;
      this.Outline_ZonaNueva.visible = false;
      this.Outline_nuevaZona3.visible = false;
      this.Outline_nuevaZona.visible = false;
      this.Cascatta2.visible = false;
      this.Outline_cascatta2.visible = false;
      gltf.scene.traverse((child) => {
        if (child.name.substring(1, 4) === "omb" && child.isMesh) {
          // child.visible=false;
          this.rombos.push(child);
        }

        //* deteccion de lotes para despues la combinacion con
        // api algunas calles no detecta por lo que se meten amanualmente el nombre de la calle
        if (this.loading) {
          if (
            (child.name.toUpperCase().includes("DISPONIBLE") ||
              child.name.toUpperCase().includes("CERRADA") ||
              child.name.toUpperCase().includes("ATENAS") ||
              child.name.toUpperCase().includes("CONSTANZA") ||
              child.name.toUpperCase().includes("LARISA") ||
              child.name.toUpperCase().includes("CUARZO") ||
              child.name.toUpperCase().includes("MARMOL") ||
              child.name.toUpperCase().includes("CALIZA") ||
              child.name.toUpperCase().includes("OPALO") ||
              child.name.toUpperCase().includes("MARELLA") ||
              child.name.toUpperCase().includes("NEREA") ||
              child.name.toUpperCase().includes("SERENA") ||
              child.name.toUpperCase().includes("GALATA") ||
              child.name.toUpperCase().includes("TAUROS") ||
              child.name.toUpperCase().includes("PERGAMO") ||
              child.name.toUpperCase().includes("CORSO") ||
              child.name.toUpperCase().includes("PONTE") ||
              child.name.toUpperCase().includes("MILANO") ||
              child.name.toUpperCase().includes("PERGAMO") ||
              child.name.toUpperCase().includes("ROSETA") ||
              child.name.toUpperCase().includes("NICOLO") ||
              child.name.toUpperCase().includes("PIETRO") ||
              child.name.toUpperCase().includes("STELLA") ||
              child.name.toUpperCase().includes("VENEZIA") ||
              child.name.toUpperCase().includes("ZARA") ||
              child.name.toUpperCase().includes("ADUA") ||
              child.name.toUpperCase().includes("AMANTI") ||
              child.name.toUpperCase().includes("_BORELLA_") ||
              child.name.toUpperCase().includes("DUOMO") ||
              child.name.toUpperCase().includes("ROSA") ||
              child.name.toUpperCase().includes("CARLO") ||
              child.name.toUpperCase().includes("LORENZO") ||
              child.name.toUpperCase().includes("LUCA") ||
              child.name.toUpperCase().includes("SANTINI") ||
              child.name.toUpperCase().includes("ITALIA") ||
              child.name.toUpperCase().includes("VECCHIO") ||
              child.name.toUpperCase().includes("CAMPANELA") ||
              child.name.toUpperCase().includes("CASOLA") ||
              child.name.toUpperCase().includes("DE_MARE") ||
              child.name.toUpperCase().includes("MOLINI") ||
              child.name.toUpperCase().includes("RIVOLO") ||
              child.name.toUpperCase().includes("ROMA") ||
              child.name.toUpperCase().includes("SABINO") ||
              child.name.toUpperCase().includes("DAVIA") ||
              child.name.toUpperCase().includes("ALANIA") ||
              child.name.toUpperCase().includes("ARGOS") ||
              child.name.toUpperCase().includes("BOCHALI") ||
              child.name.toUpperCase().includes("DROSIA") ||
              child.name.toUpperCase().includes("KAMB") ||
              child.name.toUpperCase().includes("MARATHIA") ||
              child.name.toUpperCase().includes("ROSETA") ||
              child.name.toUpperCase().includes("BELLARIA") ||
              child.name.toUpperCase().includes("CITADELLA") ||
              child.name.toUpperCase().includes("MONTENERO") ||
              child.name.toUpperCase().includes("MORATA") ||
              child.name.toUpperCase().includes("PAVONE") ||
              child.name.toUpperCase().includes("PARADISO") ||
              child.name.toUpperCase().includes("ROMANO") ||
              child.name.toUpperCase().includes("SIENA") ||
              child.name.toUpperCase().includes("DELSOL") ||
              child.name.toUpperCase().includes("VALLEROZZI") ||
              child.name.toUpperCase().includes("CASTELLO") ||
              child.name.toUpperCase().includes("DUPRE") ||
              child.name.toUpperCase().includes("FLORENTINA") ||
              child.name.toUpperCase().includes("MAGENTA") ||
              child.name.toUpperCase().includes("FONTANELLA") ||
              child.name.toUpperCase().includes("SANMARCO") ||
              child.name.toUpperCase().includes("SPERANZA") ||
              child.name.toUpperCase().includes("MONTECIELO") ||
              child.name.toUpperCase().includes("VENETO") ||
              child.name.toUpperCase().includes("GALA")) &&
            child.isMesh
          ) {
            this.lotes.push(child);
          }
        }
      });

      this.hideRombos();
      this.pintarLotes();

      // to hidden clousters

      this.Fontana = gltf.scene.getObjectByName("Fontana");
      this.Sacramento = gltf.scene.getObjectByName("Sacramento");
      this.Arcadia = gltf.scene.getObjectByName("Arcadia");
      this.Rinconada = gltf.scene.getObjectByName("Rinconada");
      this.Galena = gltf.scene.getObjectByName("Galena");
      this.Capri = gltf.scene.getObjectByName("Capri");
      this.Creta = gltf.scene.getObjectByName("Creta");
      this.Rodas = gltf.scene.getObjectByName("Rodas");
      this.Bali = gltf.scene.getObjectByName("Bali");
      this.LaCantera = gltf.scene.getObjectByName("LaCantera");
      this.Lucerna = gltf.scene.getObjectByName("Lucerna");
      this.Vilansa = gltf.scene.getObjectByName("Vilansa");
      this.Zante = gltf.scene.getObjectByName("Zante");
      this.Palermo = gltf.scene.getObjectByName("Palermo");
      this.Parque_berna = gltf.scene.getObjectByName("Parque_berna");
      this.ParqueViena = gltf.scene.getObjectByName("ParqueViena");
      this.Sofia = gltf.scene.getObjectByName("Sofia");
      this.Anturio = gltf.scene.getObjectByName("Anturio");
      this.Balcanes = gltf.scene.getObjectByName("Balcanes001");
      this.niza = gltf.scene.getObjectByName("Niza");
      this.antalya = gltf.scene.getObjectByName("Antalya");
      this.Ferrara = gltf.scene.getObjectByName("Ferrara");

      this.Sorrento = gltf.scene.getObjectByName("Sorrento");
      this.Trento = gltf.scene.getObjectByName("Trento");
      this.Verona = gltf.scene.getObjectByName("Verona");
      this.Siena = gltf.scene.getObjectByName("Siena");

      this.Terreno_parques_MT_G_terreno_0 = gltf.scene.getObjectByName(
        "Terreno_parques_MT_G_terreno_0",
        true
      );
      this.Distrito_escolar_MT_G_terreno_0 = gltf.scene.getObjectByName(
        "Distrito_escolar_MT_G_terreno_0001",
        true
      );
      this.Terreno_nuevaZona_3 = gltf.scene.getObjectByName(
        "Terreno_nuevaZona_3",
        true
      );
      this.Terreno_cascatta2_MT_G_terreno_0 = gltf.scene.getObjectByName(
        "Terreno_cascatta2_MT_G_terreno_0",
        true
      );
      this.Terreno_nuevaZona2_MT_G_terreno_0 = gltf.scene.getObjectByName(
        "Terreno_nuevaZona2_MT_G_terreno_0",
        true
      );
      this.Terreno_cascatta = gltf.scene.getObjectByName(
        "Terreno_cascatta",
        true
      );
      this.Terreno_nuevaZona_MT_G_terreno_0 = gltf.scene.getObjectByName(
        "Terreno_nuevaZona_MT_G_terreno_0",
        true
      );

      this.validateandModificateClusters();
    });
  }

  validateandModificateClusters() {
    const uiElements = [
      {
        father: this.Outline_nuevaZona,
        terrain: this.Terreno_nuevaZona_MT_G_terreno_0,
        childrens: [
          {
            //fontana
            meshElement: this.Fontana,
            slug: "A-110 B",
          },
          {
            //sacramento
            meshElement: this.Sacramento,
            slug: "A-110A",
          },
          {
            //arcadia
            meshElement: this.Arcadia,
            slug: "A-108 B",
          },
          {
            //rinconada
            meshElement: this.Rinconada,
            slug: "A-106",
          },
          {
            //galena
            meshElement: this.Galena,
            slug: "A108A/A109",
          },
        ],
      },
      {
        father: this.Outline_ZonaNueva,
        terrain: this.Terreno_nuevaZona2_MT_G_terreno_0,
        childrens: [
          {
            //capri
            meshElement: this.Capri,
            slug: "*************",
          },
          {
            //creta
            meshElement: this.Creta,
            slug: "A-91",
          },
          {
            //rodas
            meshElement: this.Rodas,
            slug: "*************",
          },
          {
            //bali
            meshElement: this.Bali,
            slug: "D-67AB/D70",
          },

          {
            //niza
            meshElement: this.niza,
            slug: "D62",
          },
          {
            //atalya
            meshElement: this.antalya,
            slug: "A-74BC",
          },
        ],
      },

      {
        father: this.Outline_cascatta2,
        terrain: this.Terreno_cascatta,
        childrens: [
          {
            //lucerna
            meshElement: this.Lucerna,
            slug: "C-30",
          },
          {
            //cantera
            meshElement: this.LaCantera,
            slug: "D-28",
          },
        ],
      },

      {
        father: this.Cascatta2,
        terrain: this.Terreno_cascatta2_MT_G_terreno_0,
        childrens: [
          {
            //vilansa
            meshElement: this.Vilansa,
            slug: "A-176",
          },
          {
            //ZANTÉ
            meshElement: this.Zante,
            slug: "A-177 B",
          },
        ],
      },
      {
        father: this.Parques_Amarillo1,
        terrain: this.Terreno_parques_MT_G_terreno_0,
        childrens: [
          {
            //parque viena
            meshElement: this.ParqueViena,
            slug: "*************",
          },
          {
            //parque berna
            meshElement: this.Parque_berna,
            slug: "*************",
          },
          {
            //palermo
            meshElement: this.Palermo,
            slug: "A-9F1",
          },
          {
            //sofia
            meshElement: this.Sofia,
            slug: "A-9D",
          },
        ],
      },

      {
        father: this.Distrito_escolar_glow,
        terrain: this.Distrito_escolar_MT_G_terreno_0,
        childrens: [
          {
            //anturio
            meshElement: this.Anturio,
            slug: "ANTURIO",
          },
          {
            //anturio
            meshElement: this.Balcanes,
            slug: "C3",
          },
        ],
      },
      {
        father: this.Outline_nuevaZona3,
        terrain: this.Terreno_nuevaZona_3,
        childrens: [
          {
            //Trento
            meshElement: this.Trento,
            slug: "A-119A",
          },
          {
            //Verona
            meshElement: this.Verona,
            slug: "A-114D",
          },
          {
            //Sorrento
            meshElement: this.Sorrento,
            slug: "A-118",
          },
          {
            //Ferrara
            meshElement: this.Ferrara,
            slug: "A-119B",
          },
          {
            //Siena
            meshElement: this.Siena,
            slug: "A-115AB",
          },
        ],
      },
    ];
    uiElements.forEach((element) => {
      const hiddenChildren = element.childrens.filter(
        (children) =>
          children.slug === "*************" ||
          this.angelApi.clusters.some(
            (clus) => clus.slug === children.slug && !clus.isOpend
          )
      );
      if (hiddenChildren.length === 0) return;
      if (hiddenChildren.length === element.childrens.length) {
        element.father.layers.set(5);
        if (element.terrain) {
          element.terrain.material = new MeshStandardMaterial({
            color: 0x889ba2,
          });
        }
      }
      hiddenChildren.forEach((children) => {
        children.meshElement.visible = false;
        element.terrain.material = new MeshStandardMaterial({
          color: 0xffffff,
        });
        children.meshElement.traverse((child) => {
          if (child.isMesh) {
            child.layers.set(5);
          }
        });
      });
      // }
    });
  }

  removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  pintarLotes() {
    //
    //
    //
    // "Abandonar toda esperanza, quienes aquí entráis"
    //
    //
    //
    //
    if (this.dataAPI.length !== 0) {
      //*** Clear and format name in API */
      this.lotes?.map((item) => {
        if (item.name === "_1RA_CERRADA_DE_BALOS_8_MT_G_noDisponible_0") {
          item.name = "1ERCDADEBALOS_8";
        }
        if (item.name === "_1RA_CERRADA_DE_BALOS_7_MT_G_noDisponible_0") {
          item.name = "1ERCDADEBALOS_7";
        }
        if (item.name === "DEL_PASO_1_MT_G_noDisponible_0") {
          item.name = "DELPASO_1_MT_G_noDisponible_0";
        }
        if (item.name === "DEL_PASO_13_MT_G_noDisponible_0") {
          item.name = "DELPASO_13_MT_G_noDisponible_0";
        }
        if (item.name === "BLVD_SIERRA_13_MT_G_noDisponible_0") {
          item.name = "BLVDSIERRA_13_MT_G_noDisponible_0";
        }
        if (item.name === "BLVD_SIERRA_19_MT_G_noDisponible_0") {
          item.name = "BLVDSIERRA_19_MT_G_noDisponible_0";
        }

        if (item.name === "CALLE_SAN_BERNARDINO_5_MT_G_disponible_0") {
          item.name = "CALLE_SAN_BERNARDITO_5_MT_G_disponible_0";
        }
        if (item.name === "CERRADA_MOLINO_1_MT_G_disponible_0") {
          item.name = "CERRADAMOLINO_1_MT_G_disponible_0";
        }
        if (item.name === "ISLA_DE_ROTI_1_MT_G_noDisponible_0") {
          item.name = "ISLA_DE_ROTIS_1_MT_G_disponible_0";
        }
        if (item.name === "CERRADA_DE_JAVA_1_MT_G_noDisponible_0") {
          item.name = "CERRADADEJAVA_1_MT_G_noDisponible_0";
        }
        if (item.name === "ISLA_DELAS_FLORES_1_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_1_MT_G_noDisponible_0";
        }
        if (item.name === "ISLA_DELAS_FLORES_11_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_11_MT_G_noDisponible_0";
        }
        if (item.name === "ISLA_DELAS_FLORES_13_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_13_MT_G_noDisponible_0";
        }
        if (item.name === "ISLA_DELAS_FLORES_3_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_3_MT_G_noDisponible_0";
        }
        if (item.name === "ISLA_DELAS_FLORES_5_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_5_MT_G_noDisponible_0";
        }
        if (item.name === "ISLA_DELAS_FLORES_7_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_7_MT_G_noDisponible_0";
        }
        if (item.name === "ISLA_DELAS_FLORES_9_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_9_MT_G_noDisponible_0";
        }
        if (item.name === "ISLAS_DE_LAS_FLORES_10_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_10_MT_G_noDisponible_0";
        }
        if (item.name === "ISLAS_DE_LAS_FLORES_12_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_12_MT_G_noDisponible_0";
        }
        if (item.name === "ISLAS_DE_LAS_FLORES_14_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_14_MT_G_noDisponible_0";
        }
        if (item.name === "ISLAS_DE_LAS_FLORES_6_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_6_MT_G_noDisponible_0";
        }
        if (item.name === "ISLAS_DE_LAS_FLORES_8_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_8_MT_G_noDisponible_0";
        }
        if (item.name === "ISLA_DE_LAS_FLORES_16_MT_G_noDisponible_0") {
          item.name = "ISLADELASFLORES_16_MT_G_noDisponible_0";
        }

        if (item.name === "RETORNO_GALA_10") {
          item.name = "RETORNO_RETORNOGALA_10";
        }
        if (item.name === "RETORNO_GALA_12") {
          item.name = "RETORNO_RETORNOGALA_12";
        }
        if (item.name === "RETORNO_GALA_14") {
          item.name = "RETORNO_RETORNOGALA_14";
        }
        if (item.name === "RETORNO_GALA_16") {
          item.name = "RETORNO_RETORNOGALA_16";
        }
        if (item.name === "RETORNO_GALA_18") {
          item.name = "RETORNO_RETORNOGALA_18";
        }
        if (item.name === "RETORNO_GALA_2") {
          item.name = "RETORNO_RETORNOGALA_2";
        }
        if (item.name === "RETORNO_GALA_4") {
          item.name = "RETORNO_RETORNOGALA_4";
        }
        if (item.name === "RETORNO_GALA_6") {
          item.name = "RETORNO_RETORNOGALA_6";
        }
        if (item.name === "RETORNO_GALA_8") {
          item.name = "RETORNO_RETORNOGALA_8";
        }
        if (item.name === "_1RA_CERRADA_MARMOL_2") {
          item.name = "_1RACERRADAMARMOL_2";
        }
        if (item.name === "_1RA_CERRADA_MARMOL_4") {
          item.name = "_1RACERRADAMARMOL_4";
        }
        if (item.name === "_1RA_CERRADA_MARMOL_6") {
          item.name = "_1RACERRADAMARMOL_6";
        }
        if (item.name === "_1RA_CERRADA_MARMOL_8") {
          item.name = "_1RACERRADAMARMOL_8";
        }

        if (item.name === "_2DA_CERRADA_MARMOL_1") {
          item.name = "_2DACERRADAMARMOL_1";
        }
        if (item.name === "_2DA_CERRADA_MARMOL_2") {
          item.name = "_2DACERRADAMARMOL_2";
        }
        if (item.name === "_2DA_CERRADA_MARMOL_3") {
          item.name = "_2DACERRADAMARMOL_3";
        }
        if (item.name === "_2DA_CERRADA_MARMOL_4") {
          item.name = "_2DACERRADAMARMOL_4";
        }
        if (item.name === "_2DA_CERRADA_MARMOL_6") {
          item.name = "_2DACERRADAMARMOL_6";
        }

        if (item.name === "CRERRADA_CALIZA_6") {
          item.name = "_CRERRADACALIZA_6";
        }
        if (item.name === "CRERRADA_CALIZA_4") {
          item.name = "_CRERRADACALIZA_4";
        }

        if (item.name === "_3ERA_CERRADA_MARMOL_2") {
          item.name = "_3ERACERRADAMARMOL_2";
        }
        if (item.name === "_3ERA_CERRADA_MARMOL_4") {
          item.name = "_3ERACERRADAMARMOL_4";
        }
        if (item.name === "_3ERA_CERRADA_MARMOL_5") {
          item.name = "_3ERACERRADAMARMOL_5";
        }
        if (item.name === "_3ERA_CERRADA_MARMOL_6") {
          item.name = "_3ERACERRADAMARMOL_6";
        }
        if (item.name === "_3ERA_CERRADA_MARMOL_7") {
          item.name = "_3ERACERRADAMARMOL_7";
        }
        if (item.name === "_3ERA_CERRADA_MARMOL_8") {
          item.name = "_3ERACERRADAMARMOL_8";
        }
        if (item.name === "_3ERA_CERRADA_MARMOL_10") {
          item.name = "_3ERACERRADAMARMOL_10";
        }
        if (item.name === "PRIVADA_MILATOS_5_MT_G_noDisponible_0") {
          item.name = "_PRIVMILATOS_5";
        }
        if (item.name === "PRIVADA_MILATOS_1_MT_G_noDisponible_0") {
          item.name = "_PRIVMILATOS_1";
        }
        if (item.name === "PRIVADA_MILATOS_10_MT_G_noDisponible_0") {
          item.name = "_PRIVMILATOS_10";
        }
        if (item.name === "PRIVADA_MILATOS_2_MT_G_noDisponible_0") {
          item.name = "_PRIVMILATOS_2";
        }
        if (item.name === "PRIVADA_MILATOS_3_MT_G_noDisponible_0") {
          item.name = "_PRIVMILATOS_3";
        }
        if (item.name === "PRIVADA_MILATOS_4_MT_G_noDisponible_0") {
          item.name = "_PRIVMILATOS_4";
        }
        if (item.name === "PRIVADA_MILATOS_5_MT_G_noDisponible_0") {
          item.name = "_PRIVMILATOS_5";
        }
        if (item.name === "PRIVADA_MILATOS_6_MT_G_noDisponible_0") {
          item.name = "_PRIVMILATOS_6";
        }
        if (item.name === "PRIVADA_MILATOS_8_MT_G_noDisponible_0") {
          item.name = "_PRIVMILATOS_8";
        }
        // balcanes

        if (item.name === "CERRADA_BELGRADO_1") {
          item.name = "_CERRADABELGRADO_1";
        }
        if (item.name === "CERRADA_BELGRADO_2") {
          item.name = "_CERRADABELGRADO_2";
        }
        if (item.name === "CERRADA_BELGRADO_3") {
          item.name = "_CERRADABELGRADO_3";
        }
        if (item.name === "CERRADA_BELGRADO_4") {
          item.name = "_CERRADABELGRADO_4";
        }
        if (item.name === "CERRADA_BELGRADO_5") {
          item.name = "_CERRADABELGRADO_5";
        }
        if (item.name === "CERRADA_BELGRADO_6") {
          item.name = "_CERRADABELGRADO_6";
        }
        if (item.name === "CERRADA_BELGRADO_7") {
          item.name = "_CERRADABELGRADO_7";
        }
        if (item.name === "CERRADA_BELGRADO_8") {
          item.name = "_CERRADABELGRADO_8";
        }
        if (item.name === "CERRADA_BELGRADO_9") {
          item.name = "_CERRADABELGRADO_9";
        }
        if (item.name === "CERRADA_BELGRADO_10") {
          item.name = "_CERRADABELGRADO_10";
        }
        if (item.name === "CERRADA_BELGRADO_11") {
          item.name = "_CERRADABELGRADO_11";
        }
        if (item.name === "CERRADA_BELGRADO_12") {
          item.name = "_CERRADABELGRADO_12";
        }
        if (item.name === "CERRADA_BELGRADO_13") {
          item.name = "_CERRADABELGRADO_13";
        }
        if (item.name === "CERRADA_BELGRADO_14") {
          item.name = "_CERRADABELGRADO_14";
        }


        if (item.name === "CERRADA_LARISA_1") {
          item.name = "_CERRADALARISA_1";
        }
        if (item.name === "CERRADA_LARISA_2") {
          item.name = "_CERRADALARISA_2";
        }
        if (item.name === "CERRADA_LARISA_3") {
          item.name = "_CERRADALARISA_3";
        }

        // if (item.name === "CERRADA_MOSTAR_1") {
        //   item.name = "_CERRADAMOSTAR_1";
        // }
        // if (item.name === "CERRADA_MOSTAR_2") {
        //   item.name = "_CERRADAMOSTAR_2";
        // }
        // if (item.name === "CERRADA_MOSTAR_3") {
        //   item.name = "_CERRADAMOSTAR_3";
        // }
        // if (item.name === "CERRADA_MOSTAR_4") {
        //   item.name = "_CERRADAMOSTAR_4";
        // }
        // if (item.name === "CERRADA_MOSTAR_5") {
        //   item.name = "_CERRADAMOSTAR_5";
        // }
        // if (item.name === "CERRADA_MOSTAR_6") {
        //   item.name = "_CERRADAMOSTAR_6";
        // }
        // if (item.name === "CERRADA_MOSTAR_7") {
        //   item.name = "_CERRADAMOSTAR_7";
        // }
        // if (item.name === "CERRADA_MOSTAR_8") {
        //   item.name = "_CERRADAMOSTAR_8";
        // }
        // if (item.name === "CERRADA_MOSTAR_9") {
        //   item.name = "_CERRADAMOSTAR_9";
        // }
        // if (item.name === "CERRADA_MOSTAR_10") {
        //   item.name = "_CERRADAMOSTAR_10";
        // }
        // if (item.name === "CERRADA_MOSTAR_11") {
        //   item.name = "_CERRADAMOSTAR_11";
        // }
        // if (item.name === "CERRADA_MOSTAR_12") {
        //   item.name = "_CERRADAMOSTAR_12";
        // }
        if (item.name === "CERRADA_TIRANA_1") {
          item.name = "_CERRADATIRANA_1";
        }
        if (item.name === "CERRADA_TIRANA_11") {
          item.name = "_CERRADATIRANA_11";
        }
        if (item.name === "CERRADA_TIRANA_3") {
          item.name = "_CERRADATIRANA_3";
        }
        if (item.name === "CERRADA_TIRANA_5") {
          item.name = "_CERRADATIRANA_5";
        }
        if (item.name === "CERRADA_TIRANA_7") {
          item.name = "_CERRADATIRANA_7";
        }
        if (item.name === "CERRADA_TIRANA_9") {
          item.name = "_CERRADATIRANA_9";
        }

        if (item.name === "CERRADA_LARISA_1") {
          item.name = "_CERRADALARISA_1";
        }
        // NIZA

        //ANTALYA
        if (item.name === "MONTE_TAUROS_23002") {
          item.name = "MONTETAUROS_23";
        }
        if (item.name === "CERRADA_PERGAMO_6") {
          item.name = "CERRADAPERGAMO_6";
        }
        if (item.name === "PERGAMO_7") {
          item.name = "PERGAMO_7";
        }
        if (item.name === "PERGAMO_6") {
          item.name = "PERGAMO_6";
        }
        if (item.name === "CERRADA_ARCO_ADRIANO_10") {
          item.name = "CERRADAARCOADRIANO_10";
        }
        if (item.name === "CERRADA_GALATA_1") {
          item.name = "CERRADAGALATA_1";
        }
        if (item.name === "CERRADA_GALATA_5") {
          item.name = "CERRADAGALATA_5";
        }
        if (item.name === "GALATA_3") {
          item.name = "GALATA_3";
        }
        if (item.name === "CERRADA_GALATA_3") {
          item.name = "CERRADAGALATA_3";
        }
        if (item.name === "MONTE_TAUROS_9") {
          item.name = "MONTETAUROS_9";
        }

        if (item.name === "CERRADA_PERGAMO_4") {
          item.name = "CDAPERGAMO 04";
        }
        if (item.name === "PERGAMO_4") {
          item.name = "PERGAMO_4";
        }
        // trento
        if (item.name === "VIA_SAN_PIETRO_20") {
          item.name = "VIASANPIETRO_20";
        }
        //
        if (item.name === "CERRADA_GALATA_4") {
          item.name = "CDAGALATA_4";
        }
        if (item.name === "CERRADA_PERGAMO_7") {
          item.name = "CERRADAPERGAMO_7";
        }
        //
        if (item.name === "SAN_GABRIEL_6_MT_G_noDisponible_0") {
          item.name = "SANGABRIEL_6";
        }
        if (item.name === "SAN_GABRIEL_6_MT_G_noDisponible_0") {
          item.name = "SANGABRIEL_6";
        }
        if (item.name === "SAN_GABRIEL_8_MT_G_noDisponible_0") {
          item.name = "SANGABRIEL_8";
        }
        if (item.name === "PRIVADA_MILATOS_6_MT_G_noDisponible_0") {
          item.name = "PRIVMILATOS_6";
        }
        if (item.name === "BLVD_SIERRA_1_MT_G_noDisponible_0") {
          item.name = "BLVDSIERRA_1";
        }
        if (item.name === "BLVD_SIERRA_3_MT_G_noDisponible_0") {
          item.name = "BLVDSIERRA_3";
        }
        if (item.name === "SAN_GABRIEL_41_MT_G_noDisponible_0") {
          item.name = "SANGABRIEL_17";
        }

        if (item.name === "CDA_DAVIA_2") {
          item.name = "CDADAVIA_2";
        }
        if (item.name === "CDA_DAVIA_4") {
          item.name = "CDADAVIA_4";
        }
        if (item.name === "CDA_DAVIA_6") {
          item.name = "CDADAVIA_6";
        }

        // Siena
        // if (item.name === "CDA_Vallerozzi_2") {
        //   item.name = "CDAVALLEROZZI_2";
        // }
        if (item.name.startsWith("CDA_")) {
          item.name = item.name.replace("CDA_", "CDA").toUpperCase();
        }
        if (item.name.startsWith("VIA_ADUA__")) {
          item.name = item.name.replace("VIA_ADUA__", "VIAADUA_").toUpperCase();
        }
        if (item.name.startsWith("VIA_SAN_")) {
          item.name = item.name.replace("VIA_SAN_", "VIASAN").toUpperCase();
        }
        if (item.name.startsWith("CERRADA_")) {
          item.name = item.name.replace("CERRADA_", "CDA").toUpperCase();
          if (item.name === "CDACONSTANZA_01") {
            console.log(item);
          }
        }
        if (item.name.startsWith("VIA_")) {
          item.name = item.name.replace("VIA_", "VIA").toUpperCase();
        }
        if (item.name.startsWith("BLVD_")) {
          item.name = item.name.replace("BLVD_", "BLVD").toUpperCase();
        }

        return item;
      });

      // this.lotes.map((item) => {
      //   console.log(item);
      //   return (item.parent.children[0].parent.children[0].children[0].material = new MeshStandardMaterial(
      //     { color: "white" }
      //   ));
      // });

      const remplaceNameApi = (name) => {
        if (name.includes("CDA.DEL.")) {
          return name.replace("CDA.DEL.", "CDADEL").toUpperCase();
        }
        if (name.includes("BLVD.")) {
          return name.replace("BLVD.", "BLVD").toUpperCase();
        }
        if (name.includes("CDA.")) {
          return name.replace("CDA.", "CDA").toUpperCase();
        }
        if (name.includes("VIA.DEL.")) {
          return name.replace("VIA.DEL.", "VIADEL").toUpperCase();
        }
        if (name.includes("VIA.SAN.")) {
          return name.replace("VIA.SAN.", "VIASAN").toUpperCase();
        }
        if (name.includes("VIA.SAN.")) {
          return name.replace("VIA.SAN.", "VIASAN").toUpperCase();
        }
        if (name.includes("VIA.")) {
          return name.replace("VIA.", "VIA").toUpperCase();
        }
        switch (name) {
          //Siena
          // case "CDA.VALLEROZZI 02":
          // return "CDAVALLEROZZI 02";
          //
          case "CDA.DAVIA 06":
            return "CDADAVIA 06";
          case "CDA.DAVIA 02":
            return "CDADAVIA 02";
          case "CDA.DAVIA 04":
            return "CDADAVIA 04";
          //
          case "SAN.GABRIEL 17":
            return "SANGABRIEL 17";
          //
          case "PRIV.MILATOS 06":
            return "PRIVMILATOS 06";
          //
          case "BLVD SIERRA 01":
            return "BLVDSIERRA 01";
          case "BLVD SIERRA 03":
            return "BLVDSIERRA 03";
          //
          case "SAN.GABRIEL 06":
            return "SANGABRIEL 06";
          case "SAN.GABRIEL 08":
            return "SANGABRIEL 08";
          //
          case "CDA.PÉRGAMO 07":
            return "CERRADAPERGAMO 07";

          // trento
          case "VIA.SAN.PIETRO 20":
            return "VIASANPIETRO 20";

          //
          // balcanes
          case "CDA.PÉRGAMO 04":
            return "CDAPERGAMO 04";

          case "PÉRGAMO 04":
            return "PERGAMO 4";
          case "PÉRGAMO 54":
            return "PERGAMO 54";
          case "PÉRGAMO 28":
            return "PERGAMO 28";

          case "PRIV.NEREA 07":
            return "PRIVNEREA 07";

          case "MONTE.TAUROS 23":
            return "MONTETAUROS 23";
          case "CDA.PÉRGAMO 06":
            return "CERRADAPERGAMO 6";
          case "CDA.GÁLATA 01":
            return "CERRADAGALATA 1";
          case "CDA.GÁLATA 05":
            return "CERRADAGALATA 5";

          case "PERGAMO 07":
            return "PERGAMO 7";
          case "MONTE.TAUROS 09":
            return "MONTETAUROS 9";
          case "PÉRGAMO 06":
            return "PERGAMO 06";
          case "GÁLATA 04":
            return "GALATA 04";
          case "GÁLATA 60":
            return "GALATA 60";
          case "GÁLATA 64":
            return "GALATA 64";
          case "GÁLATA 62":
            return "GALATA 62";
          case "CDA.GÁLATA 04":
            return "CDAGALATA 04";
          case "GÁLATA 03":
            return "GALATA 3";
          case "CDA.GÁLATA 03":
            return "CERRADAGALATA 3";

          case "CDA.ARCO.ADRIANO 10":
            return "CERRADAARCOADRIANO 10";
          //
          // case "CDA.CONSTANZA 01":
          //   return "CERRADACONSTANZA 01";
          // case "CDA.CONSTANZA 03":
          //   return "CERRADACONSTANZA 03";
          // case "CDA.CONSTANZA 05":
          //   return "CERRADACONSTANZA 05";
          case "CDA.LARISA 01":
            return "CERRADALARISA 01";
          case "CDA.BELGRADO 01":
            return "CERRADABELGRADO 01";
          case "CDA.BELGRADO 02":
            return "CERRADABELGRADO 02";
          case "CDA.BELGRADO 03":
            return "CERRADABELGRADO 03";
          case "CDA.BELGRADO 04":
            return "CERRADABELGRADO 04";
          case "CDA.BELGRADO 05":
            return "CERRADABELGRADO 05";
          case "CDA.BELGRADO 06":
            return "CERRADABELGRADO 06";
          case "CDA.BELGRADO 07":
            return "CERRADABELGRADO 07";
          case "CDA.BELGRADO 08":
            return "CERRADABELGRADO 08";
          case "CDA.BELGRADO 09":
            return "CERRADABELGRADO 09";
          case "CDA.BELGRADO 10":
            return "CERRADABELGRADO 10";
          case "CDA.BELGRADO 11":
            return "CERRADABELGRADO 11";
          case "CDA.BELGRADO 12":
            return "CERRADABELGRADO 12";
          case "CDA.BELGRADO 13":
            return "CERRADABELGRADO 13";
          case "CDA.BELGRADO 14":
            return "CERRADABELGRADO 14";
          case "CDA.LARISA 01":
            return "CERRADALARISA 01";
          case "CDA.LARISA 02":
            return "CERRADALARISA 02";
          case "CDA.LARISA 03":
            return "CERRADALARISA 03";
          case "CDA.MOSTAR 01":
            return "CERRADAMOSTAR 01";
          case "CDA.MOSTAR 02":
            return "CERRADAMOSTAR 02";
          case "CDA.MOSTAR 03":
            return "CERRADAMOSTAR 03";
          case "CDA.MOSTAR 04":
            return "CERRADAMOSTAR 04";
          case "CDA.MOSTAR 05":
            return "CERRADAMOSTAR 05";
          case "CDA.MOSTAR 06":
            return "CERRADAMOSTAR 06";
          case "CDA.MOSTAR 07":
            return "CERRADAMOSTAR 07";
          case "CDA.MOSTAR 08":
            return "CERRADAMOSTAR 08";
          case "CDA.MOSTAR 09":
            return "CERRADAMOSTAR 09";
          case "CDA.MOSTAR 10":
            return "CERRADAMOSTAR 10";
          case "CDA.MOSTAR 11":
            return "CERRADAMOSTAR 11";
          case "CDA.MOSTAR 12":
            return "CERRADAMOSTAR 12";
          case "CDA.TIRANA 01":
            return "CERRADATIRANA 01";
          case "CDA.TIRANA 11":
            return "CERRADATIRANA 11";
          case "CDA.TIRANA 03":
            return "CERRADATIRANA 03";
          case "CDA.TIRANA 05":
            return "CERRADATIRANA 05";
          case "CDA.TIRANA 07":
            return "CERRADATIRANA 07";
          case "CDA.TIRANA 09":
            return "CERRADATIRANA 09";

          

          case "CDA.CONSTANZA 01":
            return "CERRADACONSTANZA 01";
          case "CDA.CONSTANZA 02":
            return "CERRADACONSTANZA 02";
          case "CDA.CONSTANZA 03":
            return "CERRADACONSTANZA 03";

          //
          case "CDA.CALIZA 06":
            return "CRERRADACALIZA 06";

          case "CDA.MOLINO 01":
            return "CERRADAMOLINO 01";

          case "DEL PASO 13":
            return "DELPASO 13";
          case "DEL PASO 01":
            return "DELPASO 01";
          case "BLVD SIERRA 19":
            return "BLVDSIERRA 19";
          case "BLVD SIERRA 13":
            return "BLVDSIERRA 13";

          case "CDA.JAVA 01":
            return "CERRADADEJAVA 01";
          case "ISLA.DE.LAS.FLORE 01":
            return "ISLADELASFLORES 01";
          case "ISLA.DE.LAS.FLORE 11":
            return "ISLADELASFLORES 11";
          case "ISLA.DE.LAS.FLORE 13":
            return "ISLADELASFLORES 13";
          case "ISLA.DE.LAS.FLORE 03":
            return "ISLADELASFLORES 03";
          case "ISLA.DE.LAS.FLORE 05":
            return "ISLADELASFLORES 05";
          case "ISLA.DE.LAS.FLORE 07":
            return "ISLADELASFLORES 07";
          case "ISLA.DE.LAS.FLORE 09":
            return "ISLADELASFLORES 09";
          case "ISLA.DE.LAS.FLORE 10":
            return "ISLADELASFLORES 10";
          case "ISLA.DE.LAS.FLORE 12":
            return "ISLADELASFLORES 12";
          case "ISLA.DE.LAS.FLORE 14":
            return "ISLADELASFLORES 14";
          case "ISLA.DE.LAS.FLORE 06":
            return "ISLADELASFLORES 06";
          case "ISLA.DE.LAS.FLORE 08":
            return "ISLADELASFLORES 08";
          case "ISLA.DE.LAS.FLORE 16":
            return "ISLADELASFLORES 16";
          case "CDA.CALIZA 04":
            return "CRERRADACALIZA 04";
          case "RETORNO.GALA 10":
            return "RETORNOGALA 10";
          case "PRIV.MILATOS 05":
            return "PRIVMILATOS 05";
          case "RETORNO.GALA 12":
            return "RETORNOGALA 12";
          case "RETORNO.GALA 14":
            return "RETORNOGALA 14";
          case "RETORNO.GALA 16":
            return "RETORNOGALA 16";
          case "RETORNO.GALA 18":
            return "RETORNOGALA 18";
          case "RETORNO.GALA 02":
            return "RETORNOGALA 02";
          case "RETORNO.GALA 04":
            return "RETORNOGALA 04";
          case "RETORNO.GALA 06":
            return "RETORNOGALA 06";
          case "RETORNO.GALA 08":
            return "RETORNOGALA 08";
          case "1ER.CDA.MÁRMOL 02":
            return "1RACERRADAMÁRMOL 02";
          case "1ER.CDA.MÁRMOL 04":
            return "1RACERRADAMÁRMOL 04";
          case "1ER.CDA.MÁRMOL 06":
            return "1RACERRADAMÁRMOL 06";
          case "1ER.CDA.MÁRMOL 08":
            return "1RACERRADAMÁRMOL 08";
          case "2DA.CDA.MÁRMOL 01":
            return "2DACERRADAMÁRMOL 01";
          case "2DA.CDA.MÁRMOL 02":
            return "2DACERRADAMÁRMOL 02";
          case "2DA.CDA.MÁRMOL 03":
            return "2DACERRADAMÁRMOL 03";
          case "2DA.CDA.MÁRMOL 04":
            return "2DACERRADAMÁRMOL 04";
          case "2DA.CDA.MÁRMOL 06":
            return "2DACERRADAMÁRMOL 06";
          case "3RA.CDA.MÁRMOL 02":
            return "3ERACERRADAMÁRMOL 02";
          case "3RA.CDA.MÁRMOL 04":
            return "3ERACERRADAMÁRMOL 04";
          case "3RA.CDA.MÁRMOL 05":
            return "3ERACERRADAMÁRMOL 05";
          case "3RA.CDA.MÁRMOL 06":
            return "3ERACERRADAMÁRMOL 06";
          case "3RA.CDA.MÁRMOL 07":
            return "3ERACERRADAMÁRMOL 07";
          case "3RA.CDA.MÁRMOL 08":
            return "3ERACERRADAMÁRMOL 08";
          case "3RA.CDA.MÁRMOL 10":
            return "3ERACERRADAMÁRMOL 10";
          case "1ER. CDA DE BALOS 08":
            return "1ERCDADEBALOS 08";
          case "1ER. CDA DE BALOS 07":
            return "1ERCDADEBALOS 07";

          default:
            return name;
        }
      };

      const dataApi = this.dataAPI?.map((dataApi) => {
        dataApi.NombreBusqueda = remplaceNameApi(dataApi.NombreBusqueda);

        const nameOne = this.removeAccents(
          dataApi.NombreBusqueda.split(".").pop().trim()
        )
          .split(" ")
          .shift();
        const nameTwo = parseInt(
          dataApi.NombreBusqueda.split(".").pop().trim().split(" ").pop()
        );

        let hexColor = "";
        switch (dataApi.color) {
          case "MORADO":
            hexColor = 0x4b237b;
            break;

          case "MARINO":
            hexColor = 0x013e50;
            break;

          case "NARANJA":
            hexColor = 0xee623f;
            break;

          case "AZUL":
            hexColor = 0x1dade1;
            break;

          case "ROJO":
            hexColor = 0xf72f14;
            break;

          default:
            hexColor = 0x30b951;
            break;
        }

        return {
          nameNormalizate: this.removeAccents(nameOne + " " + nameTwo),
          precio: dataApi.Precio,
          detalle: dataApi.Detalle,
          color: hexColor,
        };
      });
      // console.log(dataApi);

      //*** Filter price and detail to get the names in the API */
      const newAPINoAvailable = dataApi
        ?.filter(({ precio }) => precio === 0)
        ?.map(({ nameNormalizate, color }) => {
          return {
            nameNormalizate: nameNormalizate,
            color: color,
          };
        });
      const newAPIAvailable = dataApi
        ?.filter(({ precio, detalle }) => precio !== 0 && detalle.length !== 0)
        ?.map(({ nameNormalizate, color }) => {
          return {
            nameNormalizate: nameNormalizate,
            color: color,
          };
        });

      //*** Replace one of the names in the API */
      newAPIAvailable?.map((item) => {
        // console.log(item.nameNormalizate);
        if (item.nameNormalizate === "DEL 10") {
          item.nameNormalizate = "VALLE 10";
        }

        if (item.nameNormalizate === "SAN 5") {
          item.nameNormalizate = "BERNARDITO 5";
        }

        if (item.nameNormalizate === "ROTI 1") {
          item.nameNormalizate = "ROTIS 1";
        }

        return item;
      });

      //*** Format name lotes */
      const lotes = this.lotes?.map((dataLote) => {
        const separete = this.removeAccents(
          dataLote.name.split("MT").shift().split("_").join(" ").trim()
        ).toString();
        const number = separete.split(" ").pop();
        const text = separete.split(" ");
        let newText = [];

        if (text.length === 2) {
          newText = text[0];
        } else if (text.length === 3) {
          newText = text[1];
        } else if (text.length === 4) {
          newText = text[2];
        }

        return {
          nameNormalizate: this.removeAccents(newText + " " + number),
          mesh: dataLote,
        };
      });

      const NoLotes = this.lotes?.map((dataLote) => {
        const separete = this.removeAccents(
          dataLote.name.split("MT").shift().split("_").join(" ").trim()
        ).toString();
        const number = separete.split(" ").pop();
        const text = separete.split(" ");
        let newText = [];

        if (text.length === 2) {
          newText = text[0];
        } else if (text.length === 3) {
          newText = text[1];
        } else if (text.length === 4) {
          newText = text[2];
        }

        return {
          nameNormalizate: this.removeAccents(newText + " " + number),
          mesh: dataLote,
        };
      });

      //*** Filter available lots with model materials */
      const newLotes = lotes?.map((lote) => {
        const api = newAPIAvailable?.find(
          (apis) => apis.nameNormalizate === lote.nameNormalizate
        );

        lote.color = api ? api.color : null;

        return lote;
      });

      const newNoLotes = NoLotes?.map((lote) => {
        const api = newAPINoAvailable?.find(
          (apis) => apis.nameNormalizate === lote.nameNormalizate
        );

        lote.color = api ? api.color : null;

        return lote;
      });

      //*** Change color rombo if not correct in API */
      newNoLotes?.map((item) => {
        // if (item.mesh.name === "CERRADA_SAN_BERNARDINO_5_MT_G_disponible_0") {
        //   item.color = 0x4b237b
        // }

        return item;
      });

      //*** Compare if available lotes has color with API */
      const availableIntersection = newLotes
        ?.filter(({ nameNormalizate }) =>
          newAPIAvailable.some((e) => e.nameNormalizate === nameNormalizate)
        )
        .map((item) => {
          return {
            nameNormalizate: item.nameNormalizate,
            mesh: item.mesh,
            color: item.color,
          };
        });

      //*** Compare if no available lotes has color with API */
      const noAvailableIntersetion = newNoLotes
        ?.filter(({ nameNormalizate }) =>
          newAPINoAvailable.some((e) => e.nameNormalizate === nameNormalizate)
        )
        .map((item) => {
          return {
            nameNormalizate: item.nameNormalizate,
            mesh: item.mesh,
            color: item.color,
          };
        });

      //*** Put white and gray color according to lot availability */
      // console.log(availableIntersection);
      availableIntersection?.map(
        (item) =>
          (item.mesh.material = new MeshStandardMaterial({ color: "white" }))
      );
      noAvailableIntersetion?.map((item) => {
        item.mesh.material.color.set("gray");
        item.mesh.material.roughness = 1;
      });

      //*** Put color rombos with acording color in API
      //
      // No tengo ni la mejor idea de como funciona
      // cuando exribi esto solo Dios y yo sabiamos que hacia ahora solo Dios lo sabe
      //
      // intentos fallidos de refactorizar el codigo: 2
      // (incrementar en 1 cada intento)
      // */

      availableIntersection?.map((item) => {
        // if (item.mesh.material)
        if (item.mesh.children[0]) {
          if (item.mesh.children[0].parent.children[0].children[0]) {
            item.mesh.children[0].parent.children[0].children[0].material = new MeshStandardMaterial(
              { color: item.color }
            );
          } else {
            item.mesh.children[0].material = new MeshStandardMaterial({
              color: item.color,
            });
          }
        } else {
          if (item.mesh.parent.children[0].children[0]) {
            item.mesh.parent.children[0].children[0].material = new MeshStandardMaterial(
              { color: item.color }
            );
          } else {
            item.mesh.parent.children[1].material = new MeshStandardMaterial({
              color: item.color,
            });
          }
        }
      });
      noAvailableIntersetion?.map((item) => {
        if (item.mesh.children[0]) {
          if (item.mesh.children[0].parent.children[0].children[0]) {
            item.mesh.children[0].parent.children[0].children[0].material = new MeshStandardMaterial(
              { color: item.color }
            );
          } else {
            item.mesh.children[0].material = new MeshStandardMaterial({
              color: item.color,
            });
          }
        } else {
          if (item.mesh.parent.children[0].children[0]) {
            item.mesh.parent.children[0].children[0].material = new MeshStandardMaterial(
              { color: item.color }
            );
          } else {
            item.mesh.parent.children[1].material = new MeshStandardMaterial({
              color: item.color,
            });
          }
        }
      });
      // end
    }
  }

  toggleAllLotes(isVisible) {
    if (isVisible) {
      this.allLotes.forEach((lotes) => {
        lotes.visible = true;
      });
    } else {
      this.allLotes.forEach((lotes) => {
        lotes.visible = false;
      });
    }
  }

  hoverZones(name, menu) {
    switch (name) {
      case "Terreno_cascatta2_MT_G_terreno_0":
        menu
          ? menu.hoverModelColorizeMedumCircle(
              document.querySelector("#labelZoneOne")
            )
          : false;
        this.Cascatta2.visible = true;
        this.Outline_ZonaNueva.visible = false;
        this.Parques_Amarillo1.visible = false;
        this.Outline_cascatta2.visible = false;
        // this.Glow_sin_lotes.visible = false;
        this.Outline_nuevaZona.visible = false;
        this.Distrito_escolar_glow.visible = false;
        break;
      case "Terreno_cascatta":
        menu
          ? menu.hoverModelColorizeMedumCircle(
              document.querySelector("#labelZoneSeven")
            )
          : false;
        this.Cascatta2.visible = false;
        this.Outline_cascatta2.visible = true;
        this.Outline_ZonaNueva.visible = false;
        this.Parques_Amarillo1.visible = false;
        // this.Glow_sin_lotes.visible = false;
        this.Outline_nuevaZona.visible = false;
        this.Distrito_escolar_glow.visible = false;
        break;
      case "Lomas2_MT_G_terreno_0":
        menu
          ? menu.hoverModelColorizeMedumCircle(
              document.querySelector("#labelZoneFour")
            )
          : false;
        // this.Glow_sin_lotes.visible = true;
        this.Outline_ZonaNueva.visible = false;
        this.Parques_Amarillo1.visible = false;
        this.Outline_cascatta2.visible = false;
        this.Outline_nuevaZona.visible = false;
        this.Cascatta2.visible = false;
        this.Distrito_escolar_glow.visible = false;
        break;
      case "Zona_azul_MT_G_terreno_0":
        menu
          ? menu.hoverModelColorizeMedumCircle(
              document.querySelector("#labelZoneFour")
            )
          : false;
        // this.Glow_sin_lotes.visible = true;
        this.Outline_ZonaNueva.visible = false;
        this.Parques_Amarillo1.visible = false;
        this.Outline_cascatta2.visible = false;
        this.Outline_nuevaZona.visible = false;
        this.Cascatta2.visible = false;
        this.Distrito_escolar_glow.visible = false;
        break;
      case "Lomas1_MT_G_terreno_0":
        menu
          ? menu.hoverModelColorizeMedumCircle(
              document.querySelector("#labelZoneFour")
            )
          : false;
        // this.Glow_sin_lotes.visible = true;
        this.Outline_ZonaNueva.visible = false;
        this.Parques_Amarillo1.visible = false;
        this.Outline_cascatta2.visible = false;
        this.Outline_nuevaZona.visible = false;
        this.Cascatta2.visible = false;
        this.Distrito_escolar_glow.visible = false;
        break;
      case "Terreno_nuevaZona_MT_G_terreno_0":
        menu
          ? menu.hoverModelColorizeMedumCircle(
              document.querySelector("#labelZoneOne")
            )
          : false;
        this.Outline_nuevaZona.visible = true;
        this.Outline_ZonaNueva.visible = false;
        this.Outline_cascatta2.visible = false;
        this.Parques_Amarillo1.visible = false;
        this.Cascatta2.visible = false;
        // this.Glow_sin_lotes.visible = false;
        this.Distrito_escolar_glow.visible = false;
        break;
      case "Terreno_nuevaZona2_MT_G_terreno_0":
        menu
          ? menu.hoverModelColorizeMedumCircle(
              document.querySelector("#labelZoneTwo")
            )
          : false;
        this.Outline_ZonaNueva.visible = true;
        this.Outline_nuevaZona.visible = false;
        this.Outline_cascatta2.visible = false;
        this.Parques_Amarillo1.visible = false;
        this.Cascatta2.visible = false;
        // this.Glow_sin_lotes.visible = false;
        this.Distrito_escolar_glow.visible = false;
        break;
      case "Terreno_parques_MT_G_terreno_0":
        menu
          ? menu.hoverModelColorizeMedumCircle(
              document.querySelector("#labelZoneFive")
            )
          : false;
        this.Parques_Amarillo1.visible = true;
        this.Outline_ZonaNueva.visible = false;
        this.Outline_cascatta2.visible = false;
        this.Outline_nuevaZona.visible = false;
        this.Cascatta2.visible = false;
        // this.Glow_sin_lotes.visible = false;
        this.Distrito_escolar_glow.visible = false;
        break;
      case "Distrito_escolar_MT_G_terreno_0001":
        menu
          ? menu.hoverModelColorizeMedumCircle(
              document.querySelector("#labelZoneSix")
            )
          : false;
        this.Distrito_escolar_glow.visible = true;
        this.Parques_Amarillo1.visible = false;
        this.Outline_cascatta2.visible = false;
        this.Outline_ZonaNueva.visible = false;
        this.Outline_nuevaZona.visible = false;
        this.Cascatta2.visible = false;
        // this.Glow_sin_lotes.visible = false;
        break;
      case "Terreno_nuevaZona_3":
        menu
          ? menu.hoverModelColorizeMedumCircle(
              document.querySelector("#labelZoneEight")
            )
          : false;
        this.Distrito_escolar_glow.visible = false;
        this.Parques_Amarillo1.visible = false;
        this.Outline_cascatta2.visible = false;
        this.Outline_ZonaNueva.visible = false;
        this.Outline_nuevaZona.visible = false;
        this.Cascatta2.visible = false;
        this.Outline_nuevaZona3.visible = true;
        // this.Glow_sin_lotes.visible = false;
        break;
      default:
        menu.hoverModelColorizeMedumCircle({});
        this.Distrito_escolar_glow.visible = false;
        this.Cascatta2.visible = false;
        this.Outline_cascatta2.visible = false;
        this.Parques_Amarillo1.visible = false;
        this.Outline_ZonaNueva.visible = false;
        this.Outline_nuevaZona3.visible = false;
        // this.Glow_sin_lotes.visible = false;
        this.Outline_nuevaZona.visible = false;
        break;
    }
  }

  hoverClousters(name, menu) {
    this.modelsHoverClousters.map((clouster) => {
      const found = clouster.names.find(
        (nameclouster) => nameclouster === name
      );
      if (found) {
        clouster.model.visible = true;
        if (menu) {
          menu.hoverModelColorizeClousterCircle(
            document.querySelector(clouster.label)
          );
        }
      } else {
        clouster.model.visible = false;
      }
    });
    // switch (name) {
    //     case "Banqueta_fontana_MT_G_terreno_0":
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#labelClousterOne"))
    //         break;
    //     case 'Banqueta_fontana_MT_G_cityLomas_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#labelClousterOne"))
    //         break;
    //         case 'Banqueta_sacramento_MT_G_terreno_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#labelClousterTwo"))
    //         break;
    //     case 'Banqueta_sacramento_MT_G_cityLomas_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#labelClousterTwo"))
    //         break;
    //     case 'Banqueta_arcadia_MT_G_terreno_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#labelClousterThree"))
    //         break;
    //     case 'Banqueta_arcadia_MT_G_cityLomas_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#labelClousterThree"))
    //         break;
    //     case 'Banqueta_rinconada_MT_G_terreno_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#labelClousterFour"))
    //         break;
    //     case 'Banqueta_rinconada_MT_G_cityLomas_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#labelClousterFour"))
    //         break;
    //     case 'Banqueta_capri_MT_G_cityLomas2_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#twoLabelClousterOne"))
    //         break;
    //     case 'Banqueta_capri_MT_G_cityLomas2_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#twoLabelClousterOne"))
    //         break;
    //     case 'Banqueta_Creta_MT_G_cityLomas2_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#twoLabelClousterTwo"))
    //         break;
    //     case 'Banqueta_Creta_MT_G_cityLomas2_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#twoLabelClousterTwo"))
    //         break;
    //     case 'Banqueta_rodas_MT_G_cityLomas2_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#twoLabelClousterThree"))
    //         break;
    //     case 'Banqueta_rodas_MT_G_cityLomas2_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#twoLabelClousterThree"))
    //         break;
    //     case 'Banqueta_vilansa_MT_G_Vilansa2_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#threeLabelClousterOne"))
    //         break;
    //     case 'Banqueta_vilansa_MT_G_Vilansa_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#threeLabelClousterOne"))
    //         break;
    //     case 'Banqueta_parqueViena_MT_G_zonaAzul_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#fiveLabelClousterOne"))
    //         break;
    //     case 'Banqueta_parqueViena_MT_G_zonaAzul_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#fiveLabelClousterOne"))
    //         break;
    //     case 'Banqueta_parqueBerna_MT_G_zonaAzul_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#fiveLabelClousterTwo"))
    //         break;
    //     case 'Banqueta_parqueBerna_MT_G_zonaAzul_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#fiveLabelClousterTwo"))
    //         break;
    //     case 'Banqueta_sofia_MT_G_zonaAzul_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#fiveLabelClousterThree"))
    //         break;
    //     case 'Banqueta_sofia_MT_G_zonaAzul_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#fiveLabelClousterThree"))
    //         break;
    //     case 'Banqueta_palermo_MT_G_zonaAzul_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#fiveLabelClousterFour"))
    //         break;
    //     case 'Banqueta_palermo_MT_G_zonaAzul_banqueta_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#fiveLabelClousterFour"))
    //         break;
    //     case 'Banqueta_anturio_MT_G_anturio2_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#sixLabelClousterOne"))
    //         break;
    //     case 'Banqueta_anturio_MT_G_Anturio_0':
    //         menu.hoverModelColorizeClousterCircle(document.querySelector("#sixLabelClousterOne"))
    //         break;
    //     default:
    //         menu.hoverModelColorizeClousterCircle({})
    //         break;
    // }
  }
  showRombos() {
    this.rombos.map((rombo) => {
      // console.log(rombo);
      rombo.visible = true;
      rombo.scale.set(0.1, 0.1, 0.1);
      gsap
        .timeline()
        .to(rombo.position, { duration: 1, ease: "back.out(1.2)" })
        .to(
          rombo.scale,
          { x: 1, y: 1, z: 1, duration: 1, ease: "back.out(1.2)" },
          "-=1"
        );
    });
  }
  hideRombos() {
    this.rombos.map((rombo) => {
      gsap
        .timeline()
        .to(rombo.position, { duration: 1, ease: "back.out(1.2)" })
        .to(
          rombo.scale,
          {
            x: 0.01,
            y: 0.01,
            z: 0.01,
            duration: 1,
            ease: "back.out(1.2)",
            onComplete: () => {
              // rombo.visible = false;
            },
          },
          "-=1"
        );
    });
  }

  hideAllLotes() {}

  renderAnimations() {
    this.rombos.map((rombo) => {
      rombo.rotation.y += 0.02;
    });
  }
}
